
import RequestService from './request-service';

export class PlayerMarketsRequestService extends RequestService {
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.playerMarkets;
    this.method = 'get';
    this.getParams = {
      matchID: null,
      Culture: APP_SETTINGS.player.language,
    };
    this.headers = null;
  }
}
